module.exports = __webpack_public_path__ + "img/error-503.96abfefc.jpg";